export default __webpack_public_path__ + "static/media/brand-safety-icon.dabf7b98.svg";